var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-btn" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [
                _vm._v(
                  "资产" +
                    _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") +
                    "单"
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "信息")
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.deviceAppturnVoucher, rules: _vm.voucherInfo }
        },
        [
          _c("div", { staticClass: "simple-form flex col-3" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v(
                    _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "日期"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "theDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: { type: "date", placeholder: "选择日期" },
                        model: {
                          value: _vm.deviceAppturnVoucher.theDate,
                          callback: function($$v) {
                            _vm.$set(_vm.deviceAppturnVoucher, "theDate", $$v)
                          },
                          expression: "deviceAppturnVoucher.theDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v(
                    _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "仓库"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-1-5x" },
                [
                  !_vm.isFixedWarehouse
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "warehouseId" } },
                          [
                            _c(
                              "el-select",
                              {
                                on: { change: _vm.warehouseChange },
                                model: {
                                  value: _vm.warehouseId,
                                  callback: function($$v) {
                                    _vm.warehouseId = $$v
                                  },
                                  expression: "warehouseId"
                                }
                              },
                              _vm._l(_vm.warehouseList, function(item) {
                                return _c("el-option", {
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            )
                          ],
                          1
                        )
                      ]
                    : _c("span", [
                        _vm._v(_vm._s(_vm.deviceAppturnVoucher.warehouseName))
                      ])
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c(
                "div",
                { staticClass: "inline-block mr20" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.audtoApplyState,
                            callback: function($$v) {
                              _vm.audtoApplyState = $$v
                            },
                            expression: "audtoApplyState"
                          }
                        },
                        [_vm._v("自动申请")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.audtoApplyState
                ? _c(
                    "div",
                    { staticClass: "inline-block mr20" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.autoAuditPass,
                                callback: function($$v) {
                                  _vm.autoAuditPass = $$v
                                },
                                expression: "autoAuditPass"
                              }
                            },
                            [_vm._v("自动审核")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "inline-block mr5" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.autoMaskAsIdle,
                            callback: function($$v) {
                              _vm.autoMaskAsIdle = $$v
                            },
                            expression: "autoMaskAsIdle"
                          }
                        },
                        [_vm._v("自动标记闲置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.showDeviceListDlg()
                  }
                }
              },
              [_vm._v("通用选择")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  disabled:
                    _vm.deviceAppturnVoucher.deviceItemList.length > 0 ||
                    _vm.deviceAppturnVoucher.durableItemList.length > 0
                },
                on: {
                  click: function($event) {
                    _vm.showAdvancedDlg()
                  }
                }
              },
              [_c("span", [_vm._v("快捷选择")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small ml10",
                class: { hidden: _vm.advancedData == null },
                on: {
                  click: function($event) {
                    _vm.setStaff()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(
                    "设置" +
                      _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") +
                      "人"
                  )
                ])
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "simple-form flex col-3" },
        [
          _vm.ioFlag == _vm.ioIn &&
          _vm.audtoApplyState &&
          _vm.autoAuditPass &&
          _vm.deviceAppturnVoucher.assetType != 2
            ? [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.isStarted,
                            callback: function($$v) {
                              _vm.isStarted = $$v
                            },
                            expression: "isStarted"
                          }
                        },
                        [_vm._v("领用即启用")]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.isStarted && _vm.audtoApplyState && _vm.autoAuditPass
                  ? [
                      _c("div", { staticClass: "form-group center" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-value width-1x" },
                          [
                            _c("el-date-picker", {
                              attrs: { type: "date", placeholder: "选择日期" },
                              model: {
                                value: _vm.startDate,
                                callback: function($$v) {
                                  _vm.startDate = $$v
                                },
                                expression: "startDate"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group center" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-value  width-1x" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.acctEnterWay,
                                  callback: function($$v) {
                                    _vm.acctEnterWay = $$v
                                  },
                                  expression: "acctEnterWay"
                                }
                              },
                              _vm._l(_vm.acctEnterWayList, function(item) {
                                return _c("el-option", {
                                  attrs: { label: item.text, value: item.value }
                                })
                              })
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      (_vm.deviceAppturnVoucher.deviceItemList != null &&
        _vm.deviceAppturnVoucher.deviceItemList.length > 0) ||
      (_vm.deviceAppturnVoucher.durableItemList != null &&
        _vm.deviceAppturnVoucher.durableItemList.length > 0)
        ? _c("div", { staticClass: "sim-row" }, [
            _c("div", { staticClass: "right" }, [
              _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-primary",
                  on: { click: _vm.setStaff }
                },
                [
                  _vm._v(
                    "设置" +
                      _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") +
                      "人"
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.advancedData == null
        ? _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _vm.showDeviceFlag && _vm.deviceAppturnVoucher.assetType != 2
                ? _c("el-tab-pane", {
                    attrs: { label: "单品式管理", name: "device" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showDurableFlag
                ? _c("el-tab-pane", {
                    attrs: { label: "批量式管理", name: "durable" }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.advancedData != null
        ? _c(
            "div",
            [
              _c("div", { staticClass: "simple-form" }, [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v(
                        _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") +
                          "部门"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.deviceAppturnVoucher.departName))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v(
                        _vm._s(_vm.ioFlag == _vm.ioIn ? "领用" : "归还") + "人"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.deviceAppturnVoucher.staffName))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("swb-asset-advanced-view", {
                attrs: {
                  advancedData: _vm.advancedData,
                  clearAdvanced: _vm.clearAdvanced
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "table-layout" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName == "device",
                    expression: "activeName == 'device'"
                  }
                ]
              },
              [
                _c("div", { staticClass: "simple-row" }, [
                  _c("div", { staticClass: "right" }, [
                    _vm.deviceAppturnVoucher.deviceItemList != null
                      ? _c("span", [
                          _vm._v(
                            "已选择(" +
                              _vm._s(
                                _vm.deviceAppturnVoucher.deviceItemList.length
                              ) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "table-layout",
                    staticStyle: { width: "100%", "overflow-x": "auto" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "deviceInfo",
                        attrs: { model: _vm.deviceAppturnVoucher }
                      },
                      [
                        _c(
                          "table",
                          { staticClass: "custom-tbl error-prompt" },
                          [
                            _c("thead", { staticClass: "head" }, [
                              _c("tr", { staticClass: "row" }, [
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "180" }
                                  },
                                  [_vm._v("资产描述名称")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("型号")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("规格")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("名称")]
                                ),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "250" } }, [
                                  _vm._v("商品标识码")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "250" } }, [
                                  _vm._v("外部系统编号")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "100" }
                                  },
                                  [_vm._v("分类")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "100" }
                                  },
                                  [_vm._v("分类分组")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "120" }
                                  },
                                  [_vm._v("品牌")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("财务类别")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "center" },
                                    attrs: { width: "90" }
                                  },
                                  [_vm._v("入账方式")]
                                ),
                                _vm._v(" "),
                                _vm.ioFlag == _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "130" }
                                      },
                                      [_vm._v("领用部门")]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "130" }
                                      },
                                      [_vm._v("归还部门")]
                                    ),
                                _vm._v(" "),
                                _vm.ioFlag == _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("领用人")]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("归还人")]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "160" }
                                  },
                                  [_vm._v("批次号")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "right" },
                                    attrs: { width: "100" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ioFlag == _vm.ioIn ? "领用" : "归还"
                                      ) + "数量"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "80" } }, [
                                  _vm._v("单位")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "120" }
                                  },
                                  [_vm._v("备注")]
                                ),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "150" } }, [
                                  _vm._v("操作")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              { staticClass: "body" },
                              _vm._l(
                                _vm.deviceAppturnVoucher.deviceItemList,
                                function(deviceItem, index) {
                                  return _c("tr", { staticClass: "row" }, [
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.title))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.model))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.fixedSpec))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(deviceItem.name))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.vendorUkno))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.innerNo))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.catName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getGoodsCatDevcGroupName(
                                              deviceItem.catId
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.brandName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.assetKindName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "center" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.acctEnterWayMap[
                                              deviceItem.acctEnterWay
                                            ]
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.departName))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.staffName))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(deviceItem.batchNo))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [_vm._v(_vm._s(deviceItem.quantity))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(deviceItem.theUnit))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("el-input", {
                                          staticClass: "textarea-value",
                                          attrs: { type: "textarea" },
                                          model: {
                                            value: deviceItem.memo,
                                            callback: function($$v) {
                                              _vm.$set(deviceItem, "memo", $$v)
                                            },
                                            expression: "deviceItem.memo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.deleteDevice(index)
                                              }
                                            }
                                          },
                                          [_vm._v("移除")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.setStaffInfo(index)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "设置" +
                                                _vm._s(
                                                  _vm.ioFlag == _vm.ioIn
                                                    ? "领用"
                                                    : "归还"
                                                ) +
                                                "人"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                }
                              )
                            ),
                            _vm._v(" "),
                            _c("tfoot", { staticClass: "foot" }, [
                              _vm.deviceAppturnVoucher.deviceItemList == null ||
                              _vm.deviceAppturnVoucher.deviceItemList.length ==
                                0
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          "line-height": "40px"
                                        },
                                        attrs: { colspan: "17" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-gray3" },
                                          [_vm._v("暂无数据")]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeName == "durable",
                    expression: "activeName == 'durable'"
                  }
                ]
              },
              [
                _c("div", { staticClass: "simple-row" }, [
                  _c("div", { staticClass: "right" }, [
                    _vm.deviceAppturnVoucher.durableItemList != null
                      ? _c("span", [
                          _vm._v(
                            "已选择(" +
                              _vm._s(
                                _vm.deviceAppturnVoucher.durableItemList.length
                              ) +
                              ")"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "durableInfo",
                    attrs: { model: _vm.deviceAppturnVoucher }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "table-layout",
                        staticStyle: { width: "100%", "overflow-x": "auto" }
                      },
                      [
                        _c(
                          "table",
                          { staticClass: "custom-tbl error-prompt" },
                          [
                            _c("thead", { staticClass: "head" }, [
                              _c("tr", { staticClass: "row" }, [
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "180" }
                                  },
                                  [_vm._v("资产描述名称")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("型号")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("规格")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("名称")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "100" }
                                  },
                                  [_vm._v("分类")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "100" }
                                  },
                                  [_vm._v("分类分组")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("品牌")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "150" }
                                  },
                                  [_vm._v("财务类别")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "center" },
                                    attrs: { width: "90" }
                                  },
                                  [_vm._v("入账方式")]
                                ),
                                _vm._v(" "),
                                _vm.ioFlag == _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "130" }
                                      },
                                      [_vm._v("领用部门")]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "130" }
                                      },
                                      [_vm._v("归还部门")]
                                    ),
                                _vm._v(" "),
                                _vm.ioFlag == _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("领用人")]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticClass: "required",
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("归还人")]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "160" }
                                  },
                                  [_vm._v("批次号")]
                                ),
                                _vm._v(" "),
                                _vm.ioFlag == _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("可用数量")]
                                    )
                                  : _c(
                                      "th",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("在用数量")]
                                    ),
                                _vm._v(" "),
                                _vm.ioFlag != _vm.ioIn
                                  ? _c(
                                      "th",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: { width: "100" }
                                      },
                                      [_vm._v("在用报损数量")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "right" },
                                    attrs: { width: "100" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ioFlag == _vm.ioIn ? "领用" : "归还"
                                      ) + "数量"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "right" },
                                    attrs: { width: "100" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ioFlag == _vm.ioIn
                                          ? "领用"
                                          : "归还报损"
                                      ) + "数量"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "80" } }, [
                                  _vm._v("单位")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticStyle: { "text-align": "left" },
                                    attrs: { width: "120" }
                                  },
                                  [_vm._v("备注")]
                                ),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "150" } }, [
                                  _vm._v("操作")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              { staticClass: "body" },
                              _vm._l(
                                _vm.deviceAppturnVoucher.durableItemList,
                                function(durableItem, index) {
                                  return _c("tr", { staticClass: "row" }, [
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(durableItem.title))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.model))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.fixedSpec))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.name))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(durableItem.catName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getGoodsCatDevcGroupName(
                                              durableItem.catId
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(durableItem.brandName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _vm._v(
                                          _vm._s(durableItem.assetKindName)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "center" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.acctEnterWayMap[
                                              durableItem.acctEnterWay
                                            ]
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.departName))
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.staffName))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [_vm._v(_vm._s(durableItem.batchNo))]
                                    ),
                                    _vm._v(" "),
                                    _vm.ioFlag == _vm.ioIn
                                      ? _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                durableItem.inStkAvQuantity
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(durableItem.inUseQuantity)
                                            )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.ioFlag != _vm.ioIn
                                      ? _c(
                                          "td",
                                          {
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                durableItem.inUseRuinedQuantity
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "durableItemList." +
                                                index +
                                                ".quantity",
                                              rules: {
                                                validator: _vm.quantityChange,
                                                trigger: "blur"
                                              }
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "text-right",
                                              attrs: { type: "number" },
                                              on: {
                                                change: function($event) {
                                                  _vm.changeQuantity(
                                                    durableItem
                                                  )
                                                }
                                              },
                                              model: {
                                                value: durableItem.quantity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    durableItem,
                                                    "quantity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "durableItem.quantity"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "durableItemList." +
                                                index +
                                                ".quantity2",
                                              rules: {
                                                validator: _vm.quantity2Change,
                                                trigger: "blur"
                                              }
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "text-right",
                                              attrs: { type: "number" },
                                              on: {
                                                change: function($event) {
                                                  _vm.changeQuantity2(
                                                    durableItem
                                                  )
                                                }
                                              },
                                              model: {
                                                value: durableItem.quantity2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    durableItem,
                                                    "quantity2",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "durableItem.quantity2"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(durableItem.theUnit))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("el-input", {
                                          staticClass: "textarea-value",
                                          attrs: { type: "textarea" },
                                          model: {
                                            value: durableItem.memo,
                                            callback: function($$v) {
                                              _vm.$set(durableItem, "memo", $$v)
                                            },
                                            expression: "durableItem.memo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.deleteDurable(index)
                                              }
                                            }
                                          },
                                          [_vm._v("移除")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "swb-btn-link",
                                            on: {
                                              click: function($event) {
                                                _vm.setStaffInfo(index)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "设置" +
                                                _vm._s(
                                                  _vm.ioFlag == _vm.ioIn
                                                    ? "领用"
                                                    : "归还"
                                                ) +
                                                "人"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                }
                              )
                            ),
                            _vm._v(" "),
                            _c("tfoot", { staticClass: "foot" }, [
                              _vm.deviceAppturnVoucher.durableItemList ==
                                null ||
                              _vm.deviceAppturnVoucher.durableItemList.length ==
                                0
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          "text-align": "center",
                                          "line-height": "40px"
                                        },
                                        attrs: { colspan: "16" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-gray3" },
                                          [_vm._v("暂无数据")]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-toolbar" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary mr10",
            on: { click: _vm.prevStock }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small",
            on: { click: _vm.saveAppturnVoucher }
          },
          [_vm._v("保存")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("启用日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("入账方式")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e34c660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e34c660","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceApptrurnVoucherEdit.vue
// module id = 3038
// module chunks = 0